<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- Basic Info Panel -->
        <v-col md="12" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Basic Info
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submitForm(currentStatus)" ref="costingForm">
                  <v-row class="pa-2">
                    <v-col cols="12" md="3">
                      <!-- Shipment Selection -->
                      <v-autocomplete
                        v-model="import_lc_shipment_id.value.value"
                        :items="getLcShipmentList"
                        item-title="code"
                        item-value="id"
                        label="Select Shipment"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="import_lc_shipment_id.errorMessage.value"
                        clearable
                        @update:model-value="onShipmentUpdate"
                      >
                        <template #label>
                          Shipment
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="3">

                      <!-- Currency & Conversion Rate -->
                      <v-autocomplete
                        v-model="currency_id.value.value"
                        :items="getCurrencyList"
                        item-title="code"
                        item-value="id"
                        label="Currency"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :error-messages="currency_id.errorMessage.value"
                        readonly=""
                      >
                        <template #label>
                          Currency
                          <span class="text-red-accent-4">*</span>
                        </template>
                      </v-autocomplete>
                      </v-col>

                       <v-col cols="12" md="3">
                        <v-text-field
                          v-model="conversion_rate.value.value"
                          type="number"
                          step="0.01"
                          label="Conversion Rate"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          :error-messages="conversion_rate.errorMessage.value"
                          clearable
                           @update:model-value="calculateDetails"
                        >
                          <template #label>
                            Conversion Rate(TK)
                            <span class="text-red-accent-4">*</span>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="3">
                        <v-date-input
                          v-model="date.value.value"
                          label="Costing Date"
                          input-format="dd/mm/yyyy"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          prepend-icon=""
                          :error-messages="date.errorMessage.value"
                          clearable
                        ></v-date-input>
                      </v-col>

                      <v-col cols="12">
                        <v-textarea
                          v-model="remarks.value.value"
                          label="Remarks"
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          rows="3"
                          clearable
                        ></v-textarea>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Costing Details Panel -->
        <v-col md="12" cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Costing Details
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submitForm(currentStatus)" ref="costingForm">
                  <v-row>
                    <v-col cols="12">
                      <v-table dense class="mt-3 elevation-1 no-wrap-table" >
                        <thead>
                          <tr>
                            <th>Product</th>
                            <th>Qty(KGs)</th>
                            <th>Rate/KG (PI)</th>
                            <th>Total Value</th>
                            <th>Value in TK</th>
                            <th>Duty, Ins & BC %</th>
                            <th>Duty, Ins & BC</th>
                            <th>LC Cost TK</th>
                            <th>Freight Charge</th>
                            <th>LC Cost / Kg</th>
                            <th>Profit %</th>
                            <th>Profit TK</th>
                            <th>AIT %</th>
                            <th>AIT TK</th>
                            <th>Vatable Price</th>
                            <th>VAT %</th>
                            <th>VAT</th>
                            <th>With VAT</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in details" :key="index">
                            <td style="padding: 2px;"> <v-autocomplete style="width: 200px;"  v-model="item.product_id" :items="getProductMapList" :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'" item-value="id" hide-details density="compact"  variant="outlined" clearable readonly disabled ></v-autocomplete></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.qty" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.rate" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.total_value" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.value_in_tk" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width: 200px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.duty_ind_bc_charge_percent" @update:model-value="calculateDetails" type="number" density="compact" variant="outlined" :max="100" hide-details style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.duty_ind_bc_charge" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.lc_cost_in_tk" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.freight_charge" type="number" density="compact" variant="outlined" hide-details style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.lc_cost_per_kg" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.profit_percent" @update:model-value="calculateDetails" type="number" density="compact" variant="outlined" :max="100" hide-details style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.profit" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.ait_percent" @update:model-value="calculateDetails" type="number" density="compact" variant="outlined" :max="100" hide-details style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.ait" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.vatable_price" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.vat_percent" @update:model-value="calculateDetails" type="number" density="compact" variant="outlined" :max="100" hide-details style="width:100px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.vat" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-text-field v-model="item.with_vat" type="number" density="compact" variant="outlined" hide-details readonly disabled style="width:150px;"></v-text-field></td>
                            <td style="padding: 2px;"><v-btn icon color="red" @click="removeDetailRow(index)"> <v-icon>mdi-delete</v-icon> </v-btn></td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-col>
                  </v-row>

                  <!-- Save Buttons -->
                  <v-row class="pt-4">
                    <v-col cols="12" class="d-flex justify-end" style="gap: 12px;">
                      <v-btn class="bg-grey-darken-1" @click="submitForm(0)">DRAFT</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">POST</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";


const panel = ref([0]);
const panel1 = ref([0]);
const store = useStore();
const router = useRouter();
const route = useRoute();

const branchId = computed(() => { return store.getters.getAuthUser?.branch_id || null;});
const getCurrencyList = computed(() => {return store.getters.getCurrencyList || [];});

const getProductMapList = computed(() => {
  let products = store.getters.getProductMapList || [];
  return products.filter(
    (item) => item.branch_id == branchId.value && item.status == 1
  );
});

const { handleSubmit } = useForm({
  validationSchema: yup.object({
    import_lc_shipment_id: yup.number().required().label("Shipment"),
    currency_id: yup.number().required().label("Currency"),
    conversion_rate: yup.number().required().min(0).label("Conversion Rate"),

    // details: yup.array().of(
    //   yup.object().shape({
    //     product_id: yup.number().required("Product is required"),
    //     qty: yup.number().required("Qty is required").min(0),
    //     rate: yup.number().required("Rate is required").min(0),
    //     total_value: yup.number().required().min(0),
    //     value_in_tk: yup.number().required().min(0),
    //     duty_ind_bc_charge_percent: yup.number().required().min(0),
    //     duty_ind_bc_charge: yup.number().required().min(0),
    //     lc_cost_in_tk: yup.number().required().min(0),
    //     freight_charge: yup.number().required().min(0),
    //     lc_cost_per_kg: yup.number().required().min(0),
    //     profit_percent: yup.number().required().min(0),
    //     profit: yup.number().required().min(0),
    //     ait_percent: yup.number().required().min(0),
    //     ait: yup.number().required().min(0),
    //     vatable_price: yup.number().required().min(0),
    //     vat_percent: yup.number().required().min(0),
    //     with_vat: yup.number().required().min(0),
    //   })
    // )
    // .min(1, "At least one detail item is required")
    // .required(),


  }),
});

const import_lc_shipment_id = useField("import_lc_shipment_id");
const currency_id = useField("currency_id");
const conversion_rate = useField("conversion_rate");
const date = useField("date");
const remarks = useField("remarks");
const status = useField("status");
const details = ref([]);
const lc_id = ref(null);
const getLcShipmentList = ref([]);
const lc_costing_id = ref(null);

const currentStatus = ref(0);
const selectedShipment = ref(null);

const onShipmentUpdate = (newId) => {
  selectedShipment.value = getLcShipmentList.value.find((s) => s.id === newId) || null;
  if (selectedShipment.value) { 
    currency_id.value.value = selectedShipment.value.lc_master?.currency_id;
    details.value = selectedShipment.value?.shipment_items || [];
    lc_id.value = selectedShipment.value?.lc_id ?? null;
  } else {
    currency_id.value.value = null;
    details.value = [];
    lc_id.value = null;
  }
  calculateDetails();
};

const calculateDetails = () =>{
  details.value.forEach((item, index) => {
    item.import_lc_shipment_item_id = item.id;
    item.total_value = item.qty * item.rate;
    item.value_in_tk = item.total_value * (conversion_rate.value.value ?? 0);
    item.duty_ind_bc_charge = (item.value_in_tk ?? 0) * ((item.duty_ind_bc_charge_percent ?? 0) / 100);
    item.lc_cost_in_tk = item.value_in_tk + item.duty_ind_bc_charge;
    item.lc_cost_per_kg = item.lc_cost_in_tk / item.qty;
    item.profit = (item.lc_cost_per_kg ?? 0) * ((item.profit_percent ?? 0) / 100);
    item.ait = (item.lc_cost_per_kg ?? 0) * ((item.ait_percent ?? 0) / 100);
    item.vatable_price = item.lc_cost_per_kg + item.profit + item.ait;
    item.vat = (item.vatable_price ?? 0) * ((item.vat_percent ?? 0) / 100);
    item.with_vat = item.vatable_price + item.vat;
  });
}

const removeDetailRow = (index) => {
  details.value.splice(index, 1);
};

const submitForm = (btnStatus) => {
  currentStatus.value = btnStatus;
  status.value.value = btnStatus;
  submit();
};

const submit = handleSubmit(async (values) => {
  try {
    let Payload = {
      lc_costing_id:lc_costing_id.value,
      lc_id:lc_id.value,
      import_lc_shipment_id: import_lc_shipment_id.value.value,
      currency_id: currency_id.value.value,
      conversion_rate: conversion_rate.value.value,
      date: date.value.value,
      remarks: remarks.value.value,
      status: status.value.value,
      details: details.value,
    };
    store.commit("SET_LOADING", { color: "primary" });
    await store.dispatch('lcImportLcCosting/saveUpdateLcImportLcCosting', Payload);
    store.commit("UNSET_LOADING");
    toast.success(status.value.value === 0 ? "LC Costing saved as draft successfully" : "LC Costing posted successfully");
    router.push({ name: 'lc-import-lc-costing-records' });

    toast.success("LC Costing saved successfully! (Replace with API call)");
  } catch (err) {
    store.commit("UNSET_LOADING");
    toast.error("Failed to save LC Costing");
  }
});

const loadExistingData = async () => {
  if (route.params.id) {
    try {
      await store.dispatch("lcImportLcCosting/getLcImportLcCostingById", route.params.id);
      const costingData = store.getters["lcImportLcCosting/getEditingLcImportLcCosting"];
      
      if (costingData) {
        lc_costing_id.value = costingData.id;
        lc_id.value = costingData.lc_id;
        conversion_rate.value.value = costingData.conversion_rate;
        date.value.value = costingData.date;
        remarks.value.value = costingData.remarks;
        currency_id.value.value = costingData.currency_id; 
        details.value = costingData.details;
        getLcShipmentList.value =  [costingData.shipment];
        import_lc_shipment_id.value.value = costingData.shipment?.id;
      }
    } catch (error) {
      toast.error("Failed to load costing data");
    } finally {
    }
  }
};

onMounted(async () => {
  store.commit("SET_LOADING", { color: "primary" });
  await store.dispatch('getCurrencyList');
  await store.dispatch("getProductMapList", {});

  if (route.params.id) {
    await loadExistingData();
  } else {
    await store.dispatch('getLcImportLcShipmentList');
    getLcShipmentList.value = store.getters.getLcImportLcShipmentList || [];
  }
  store.commit("UNSET_LOADING");

});
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

.v-table th,
.v-table td {
  font-size: 12px;
  padding: 4px 8px;
}

.v-table th {
  background-color: #f5f5f5;
  font-weight: 600;
}

.no-wrap-table th,
.no-wrap-table td {
  white-space: nowrap;
}
</style>